module.exports = __webpack_public_path__ + "img/border_Circular_Right_Top.b75e6eca.svg";